import React from "react";
import { Link } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import Layout from "../../Layout";
import PersonalInfo from "../../components/UsedComp/PersonalInfo";

function CreatePatient() {
  return (
    <Layout>
      <div className="flex items-center gap-4">
        <Link
          to="/staffs"
          className="bg-dry border border-border rounded-lg py-3 px-4 text-md text-redlight"
        >
          <IoArrowBackOutline />
        </Link>
        <h1 className="text-text font-semibold text-subMain">Create Staff</h1>
      </div>
      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
        data-aos-offset="200"
        className="bg-dry my-8 rounded-xl border-[1px] border-border p-6"
      >
        <PersonalInfo titles={false} />
      </div>
    </Layout>
  );
}

export default CreatePatient;
